import { ResponseModal2Component } from './../../../components/response-modal2/response-modal2.component';
import { StorageService } from './../../../services/storage.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { UsersService } from '../../../services/admin/users.service';
import { newUser } from '../../../models/newUser';
import { ToasterModule, ToasterService, Toast } from 'angular5-toaster';
import { TranslateService } from '@ngx-translate/core';
import { element } from 'protractor';
import { User } from '../../../models/user';
import { copyConfig } from '@angular/router/src/config';
import { passwordValidator } from '../../../shared/validators/password.validator';


@Component({
  selector: 'app-form-register',
  templateUrl: './form-register.component.html',
  styleUrls: ['./form-register.component.scss']
})
export class FormRegisterComponent implements OnInit {
  @ViewChild('popover') popover: NgbPopover | undefined;

  public user: User;
  rows_sociedades = [];
  centros_costo = [];
  public registrationForm: FormGroup;
  public submitted: Boolean = false;
  public error = null;
  public isCustomer: boolean = true;
  public sociedad: string = "";
  public orgVnts: string = "";
  public ofVnts: string = "";
  public invalidPass: boolean = false;
  public existSoc: boolean = false;
  public existOrg: boolean = false;
  public existOfi: boolean = false;

  sociedades: Array<any> = [];
  orgVentas: Array<any> = [];
  ofiVentas: Array<any> = [];

  todosSociedad: boolean = false;
  todosOrgVnts: boolean = false;
  todosOfVnts: boolean = false;
  Ventas: boolean = false;
  Finanzas: boolean = false;
  Ambos: boolean = false;
  Opcion;
  toastErrorRegistroUsuario;
  tituloError;
  validarCampos;


  constructor(
    private translate: TranslateService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    public userService: UsersService,
    private toasterService: ToasterService,
    private storageService: StorageService
  ) {
    this.translate.get('texto.toastErrorRegistroUsuario').subscribe(
      text => {
        this.toastErrorRegistroUsuario = text;
      });
    this.translate.get('texto.error').subscribe(
      text => {
        this.tituloError = text;
      }); 
      this.translate.get('texto.toastCamposVacios').subscribe(
      text => {
        this.validarCampos = text;
      });
      
  }

  ngOnInit() {
    this.user = this.storageService.getCurrentUser(); console.log(this.user);
    this.sociedades = [];
    this.orgVentas = [];
    this.ofiVentas = [];
    this.registrationForm = this.formBuilder.group({
      /* name: ['', Validators.compose([
        Validators.required, Validators.minLength(2), Validators.maxLength(20), this.noWhitespaceValidator
      ])], */
      userId: ['', Validators.required],
      usuario: ['', Validators.compose([ Validators.maxLength(20), Validators.required, Validators.pattern( "^[A-Za-z0-9]*$" )])],
      rfc: ['',],
      nombre: ['', Validators.required],
      correo: ['', Validators.compose([Validators.required,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'),
      Validators.minLength(1)])],
      password: ['', [Validators.required, passwordValidator]],
      confpassword: ['', Validators.required],
      telefono: ['', Validators.max(999999999999999999999999999999999999999999999)],
      direccion: [''],
      rol: ['', Validators.required]
    });
  }


  closeModal() {
    this.activeModal.close('Modal Closed');
  }

  public noWhitespaceValidator(control: FormControl) {
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true }
  }

  public submitUserData(): void {
    // console.log("trying to dregister user..", this.registrationForm);
    this.submitted = true;
    this.error = null;
    let p1 = this.registrationForm.get("password").value;
    let p2 = this.registrationForm.get("confpassword").value;
    let rol = this.registrationForm.get("rol").value;
    
    // console.log(this.Ventas, this.Finanzas, this.Ambos, this.Opcion);
    if (this.registrationForm.valid) {

      var enviar = false;
      if (rol === '3') {
        if (!this.todosSociedad) {
          if (this.sociedades.length !== 0) {
            enviar = true;
          } else {
            enviar = false;
          }
        } else {
          enviar = true;
        }
      } else {
        if (this.todosSociedad && this.todosOrgVnts && this.todosOfVnts) {
          enviar = true;
        } else if (this.todosSociedad && !this.todosOrgVnts && !this.todosOfVnts) {
          if (this.orgVentas.length == 0 && this.ofiVentas.length == 0) {
            enviar = false;
          } else {
            enviar = true;
          }
        } else if (this.todosSociedad && this.todosOrgVnts && !this.todosOfVnts) {
          if (this.ofiVentas.length == 0) {
            enviar = false;
          } else {
            enviar = true;
          }
        } else if (!this.todosSociedad && this.todosOrgVnts && this.todosOfVnts) {
          if (this.sociedades.length == 0) {
            enviar = false;
          } else {
            enviar = true;
          }
        } else if (!this.todosSociedad && !this.todosOrgVnts && this.todosOfVnts) {
          if (this.sociedades.length == 0 && this.orgVentas.length == 0) {
            enviar = false;
          } else {
            enviar = true;
          }
        } else if (!this.todosSociedad && !this.todosOrgVnts && !this.todosOfVnts) {
          if (this.sociedades.length == 0 && this.orgVentas.length == 0 && this.ofiVentas.length == 0) {
            enviar = false;
          } else {
            enviar = true;
          }
        }
      }

      var todosSoc, todosOfi, todosOrg;
      if (this.todosSociedad) {
        todosSoc = 1;
      } else {
        todosSoc = 0;
      }
      if (this.todosOrgVnts) {
        todosOrg = 1;
      } else {
        todosOrg = 0;
      }
      if (this.todosOfVnts) {
        todosOfi = 1;
      } else {
        todosOfi = 0;
      }

      if (enviar && this.Opcion !== undefined) {
        let userData: newUser = this.registrationForm.value;
        userData.sociedades = this.sociedades;
        userData.orgVentas = this.orgVentas;
        userData.ofiVentas = this.ofiVentas;
        userData.activo = true;
        userData.todosSoc = todosSoc;
        userData.todosOfi= todosOfi;
        userData.todosOrg= todosOrg;
        userData.permiso = this.Opcion;

        userData.userId = userData.userId.trim();
        userData.nombre = userData.nombre.trim();
        userData.direccion = userData.direccion.trim();
        if (userData.rfc != undefined) {
          userData.rfc = userData.rfc.trim();
        }

        const passwordControl = this.registrationForm.get('password');

        // si la contraseña no cumple con los requisitos, se muestra el popover
        if (passwordControl && passwordControl.errors) {
          if (this.popover) this.popover.open();
          
          return;
        }

        if (p1.trim() !== p2.trim()) {
          // console.log('contraseñas distintas');
          this.invalidPass = true;
        } else {
          this.invalidPass = false;
          
          this.userService.createUser(userData).subscribe(
            data => {
              if (data != null) {

                this.correctRegistration(data);
              }

            },
            error => {
              if (error.status === 401) {
                this.storageService.openLogout();
              } else {
                // console.log(error);
              }
              console.log(error);
              this.error = error

              if (this.error.status == 500) {
                const modalRef = this.modalService.open(ResponseModal2Component, { centered: true, keyboard: false, backdrop: 'static' });
                modalRef.componentInstance.titulo = this.tituloError;
                modalRef.componentInstance.mensaje1 = this.error.error.mensaje;
              }

            }
          );
        }
      }

    } else {
      this.toasterService.pop('error', this.validarCampos);
    }
  }

  selectChange(value: any) {
    if (parseInt(value) == 2) {
      this.isCustomer = true;
      this.registrationForm.get("rfc").setValidators([Validators.required]);
      this.registrationForm.get("rfc").updateValueAndValidity();
    } else {
      this.isCustomer = false;
      this.registrationForm.get("rfc").clearValidators();
      this.registrationForm.get("rfc").updateValueAndValidity();
    }
  }


  private correctRegistration(data) {
    if (data != null) {
      // console.log(data);
      if (data.status == 201) {
        this.activeModal.close('success');
        this.toasterService.pop('success', data.body.mensaje);
      } else {
        this.toasterService.pop('error', data.body.mensaje);
      }
    } else {
      //Handle no sesion data
      this.toasterService.pop('error', this.toastErrorRegistroUsuario);
    }
  }


  addSociedad() {
    let band: boolean = false;
    this.existSoc = false;
 
    if (this.sociedad != '') {
      this.sociedad = this.sociedad.trim();

      this.sociedades.forEach(element => {
        if (element.sociedad == this.sociedad) {
          band = true;
        }
      });

      if (band) {
        this.existSoc = true;
      } else {
        this.existSoc = false;
        this.sociedades.push({ sociedad: this.sociedad });
        // this.sociedad = '';
      }
    }
  }

  addOrgVnts() {
    let band: boolean = false;
    this.existOrg = false;
    if (this.orgVnts != '') {
      this.orgVnts = this.orgVnts.trim();

      this.orgVentas.forEach(element => {
        // console.log(element);
        if (element.orgVentas == this.orgVnts) {
          band = true;
        }
      });

      if (band) {
        this.existOrg = true;
      } else {
        this.existOrg = false;
        this.orgVentas.push({ orgVentas: this.orgVnts });
        // this.orgVnts = '';
      }

    }
  }

  addOfVnts() {
    let band: boolean = false;
    this.existOfi = false;
    if (this.ofVnts != '') {
      this.ofVnts = this.ofVnts.trim();
      
      this.ofiVentas.forEach(element => {
        // console.log(element);
        if (element.oficinaVen == this.ofVnts) {
          band = true;
        }
      });

      if (band) {
        this.existOfi = true;
      } else {
        this.existOfi = false;
        this.ofiVentas.push({ oficinaVen: this.ofVnts });
        // this.ofVnts = '';
      }

    }
  }

  eliminarSociedad(sociedad) {
    // console.log(sociedad);
    this.sociedades.forEach((element, i) => {
      if (element.sociedad == sociedad) {
        this.sociedades.splice(i, 1);
      }
    });
  }

  eliminarOrgVnts(orgV) {
    // console.log(orgV);
    this.orgVentas.forEach((element, i) => {
      if (element.orgVentas == orgV) {
        this.orgVentas.splice(i, 1);
      }
    });
  }

  eliminarOfVnts(ofV) {
    // console.log(ofV);
    this.ofiVentas.forEach((element, i) => {
      if (element.oficinaVen == ofV) {
        this.ofiVentas.splice(i, 1);
      }
    });
  }

  telInvalid:boolean = false;
  checkNumber() {
    if (this.registrationForm.controls.telefono.valid) {
      this.telInvalid = false;
    } else {
      this.telInvalid = true;
    }
    
  }

  // validaciones de contraseña segura
  passwordHasError(errorKey: string): boolean {
    const passwordControl = this.registrationForm.get('password');
    if (!passwordControl || !passwordControl.errors) {
      return true; // no hay error
    }

    return !passwordControl.errors[errorKey];
  }

  get hasMinLength(): boolean { return this.passwordHasError('minLength') }
  get hasUppercase(): boolean { return this.passwordHasError('noUppercase') }
  get hasLowercase(): boolean {  return this.passwordHasError('noLowercase') }
  get hasNumber(): boolean {  return this.passwordHasError('noNumber') }
  get hasSpecialChar(): boolean { return this.passwordHasError('noSpecial') }

}



// WEBPACK FOOTER //
// ./src/app/pages/users/form-register/form-register.component.ts